/**
 * Whether IndexedDB is usable here. Absent under Lockdown Mode — iOS strips it
 * from WebViews and Safari strips it from the page itself.
 *
 * Kept in its own module so boot code can gate the (heavier) stand-in imports
 * on it without pulling `fake-indexeddb` into the entry bundle.
 */
export function hasIndexedDB(): boolean {
  return (
    typeof globalThis.indexedDB !== "undefined" && globalThis.indexedDB != null
  );
}

/**
 * Whether IndexedDB was missing when this module first evaluated — the
 * Lockdown Mode signature. `hasIndexedDB()` cannot answer this later: both
 * stand-ins (lockdownStandInStorage, memoryStandInStorage) install a fake
 * into the global, and both consult `hasIndexedDB()` before installing, so
 * this module always evaluates while the global still reflects the real
 * platform.
 */
export const indexedDBWasMissingAtBoot = !hasIndexedDB();
